<template>
  <div class="wrapper">
    <img class="wrapperBg" width="100%" height="100%" src="../../assets/img/sy/dzp/dzpbg1.png">
    <div class="header">
      <div class="tabBtn">
        <img @click="tabChange(0)" v-show="!pressTabClass" src="../../assets/img/sy/dzp/giftTab1.png">
        <img @click="tabChange(0)" v-show="pressTabClass" src="../../assets/img/sy/dzp/giftTab.png">
        <img @click="tabChange(1)" v-show="!pressTabClass" src="../../assets/img/sy/dzp/superTab.png">
        <img @click="tabChange(1)" v-show="pressTabClass" src="../../assets/img/sy/dzp/superTab1.png">
      </div>
      <div class="goPay" v-show="!token" @click="recharge">
        <span>请登录</span>
      </div>
      <div class="goPay" v-show="!!token" @click="recharge">
        <img src="../../assets/img/sy/dzp/icon.png">
        <span>{{user.money}}</span>
      </div>
    </div>
    <div class="msgBox" ref="msgWidth">
      <scroll-seamless
        :data="pressMsgList"
        :class-option="classOption">
        <ul class="msgListBox">
          <li class="list-item" ref="listItem" v-for="(item,index) in pressMsgList" :key="index">
            <div class="name">{{item.userinfo.username}}</div>
            <div class="chouzhong">抽中</div>
            <div class="give">{{item.giftinfo.name}}</div>
          </li>
        </ul>
      </scroll-seamless>
    </div>
    <div class="twoBtn">
      <img @click="openInfo" src="../../assets/img/sy/dzp/info1.png">
      <img @click="openPrize" src="../../assets/img/sy/dzp/zjjl1.png">
      <img @click="openShop" src="../../assets/img/sy/dzp/shop1.png">
    </div>
    <div class="press" v-if="!pressTabClass">
      <div class="pressBtn" :class="[num == 1 ? 'yes' : '']" @click="changeNum(1)">
        <img src="../../assets/img/sy/dzp/100dou.png">
        <i></i>
      </div>
      <div class="pressBtn" :class="[num == 10 ? 'yes' : '']" @click="changeNum(10)">
        <img src="../../assets/img/sy/dzp/1000dou.png">
        <i></i>
      </div>
      <div class="pressBtn" :class="[num == 30 ? 'yes' : '']" @click="changeNum(30)">
        <img src="../../assets/img/sy/dzp/3000dou.png">
        <i></i>
      </div>
    </div>
    <div class="press" v-if="pressTabClass == 1">
      <div class="pressBtn" :class="[num == 1 ? 'yes' : '']" @click="changeNum(1)">
        <img src="../../assets/img/sy/dzp/500dou.png">
        <i></i>
      </div>
      <div class="pressBtn" :class="[num == 10 ? 'yes' : '']" @click="changeNum(10)">
        <img src="../../assets/img/sy/dzp/5000dou.png">
        <i></i>
      </div>
      <div class="pressBtn" :class="[num == 30 ? 'yes' : '']" @click="changeNum(30)">
        <img src="../../assets/img/sy/dzp/15000dou.png">
        <i></i>
      </div>
    </div>
    <!--九宫格-->
    <div id="weel_surf" class="weel-pointer-box" v-if="gifts[pressTabClass]">
      <div class="colorBg">
        <div class="luckBg">
          <ul class="luckList">
            <li class="item" :class="{'luck': index==4 }" v-for="(item,index) in gifts[pressTabClass].list" :key="index" :type="[index<4 ? index+1:index!=4?index:'']" ref="pice">
              <div v-if="index !=4 "><img :src="item.icon"><span class="name">{{item.name}}</span><span class="border"></span></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!--转盘-->
    <!--<div id="wheel_surf" v-if="gifts[pressTabClass]">-->
      <!--<div class="lucky-wheel">-->
        <!--<div class="wheel-main">-->
          <!--<div class="wheel-pointer-box">-->
            <!--<div class="wheel-pointer" @click="clickZPBtn" :style="{transform:turntable.rotate_angle_pointer,transition:turntable.rotate_transition_pointer}"></div>-->
          <!--</div>-->
          <!--<div class="wheel-bg" :style="{transform:turntable.rotate_angle,transition:turntable.rotate_transition}">-->
            <!--<div class="prize-list">-->
              <!--<div class="prize-item" v-for="(item,index) in gifts[pressTabClass].list" :key="index">-->
                <!--<div class="prize-type">-->
                  <!--{{item.name}}-->
                <!--</div>-->
                <!--<div class="prize-pic" v-if="item.icon">-->
                  <!--<img :src="item.icon" />-->
                <!--</div>-->
              <!--</div>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
    <!--</div>-->
    <div id="jdt">
      <div class="jdtbg" ref="jdtbg">
        <div class="keduBox">
          <div class="kedu" ref="kedu" :style="{opacity: i==1||i==jdt.count ? '0' : '1'}" :class="{active:i%2==1}" v-for="i in jdt.count" :key="i"></div>
        </div>
        <div class="jdtc" :style="{width: (jdt.nowWidth-6<0? 0 : jdt.nowWidth) + 'px'}"></div>
      </div>
      <div class="tipBox" :style="{left: (jdt.tipsLeft-25 >= 190 ? 190 : jdt.tipsLeft-25) + 'px'}">
        <div class="h4">
          <div>第{{jdt.nextStep}}次抽奖用户</div>
          <div>额外获得{{jdt.nextGift}}x1</div>
        </div>
      </div>
      <span class="sanjiao" :style="{left: jdt.tipsLeft-4 + 'px'}"></span>
    </div>
    <div id="hdgz"></div>
    <van-popup
      v-model="msgShow"
      position="bottom"
      overlay-class="overlayClass"
      :lock-scroll="true">
      <div class="lwTitle">
        <img src="../../assets/img/sy/dzp/lwTitle1.png">
      </div>
      <div class="bigLucks" v-show="!!rewardPrize" :style="rewardPrize.length <= 1 ? 'justify-content : center;': ''">
        <div class="bigLucksBox" v-for="(item,i) in rewardPrize" :key="i">
          <div class="luckImgBg">
            <div class="bigLkT">特殊奖励</div>
            <img class="luckImg" :src="item.icon">
          </div>
        </div>
      </div>
      <div class="luckBox" :style="prize.length <= 1 ? 'justify-content : center;': ''">
        <div class="lucksBox" v-for="(item,i) in prize" :key="i">
          <div class="luckImgBg">
            <img class="luckImg" :src="item.icon">
            <p class="luckText">x{{item.nums}}</p>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import { Popup,Progress } from 'vant'
  import axios from 'axios'
  import dsBridge from '../../component/dsbridge'
  import scroll from 'vue-seamless-scroll'

  export default {
    name: 'sy_dzp',
    data () {
      return {
        API_DOMAIN: window.location.host.match(/mp\.le/)||window.location.host.match(/localhost/) ? 'https://test-api-svoice.le.com' : 'https://api-svoice.le.com',
        gameid: 3,
        // 本地调试使用
//        token: '8cc0e4a43aceaa54d6c296ae9edccbd1b6718e232f3f7eb4aeba56d27956863369583c47fdd3d86d54cfeb669c6e438af456bf39901772633a4365ba5f013d63b85452ac779eabbc6e5c565a3d0196a9',
//        pcode: '230110000',
//        version: '3.4',
        token: '',
        pcode: '',
        version: '',

        pressTabClass: 0,
        num: 1,
        allSum: 0,
        pressPrizes:[
          {
            1: 100,
            10: 1000,
            30: 3000
          },
          {
            1: 500,
            10: 5000,
            30: 15000
          }
        ],
        pressTab: window.location.host.match(/mp\.le/)||window.location.host.match(/localhost/) ? '112' : '101',
        pressTabs:window.location.host.match(/mp\.le/)||window.location.host.match(/localhost/) ? ['112','113'] : ['101','102'] ,
        playid:'',
        prize: '',
        rewardPrize: '',
        user:{
          name: '请登录',
          money: '',
          headImg: ''
        },
        //奖品列表
        gifts:[],
        pressMsgList: [],
        hasPrize: false, //是否中奖
        turntable: {
          start_rotating_degree: 0, //初始旋转角度
          rotate_angle: 0, //将要旋转的角度
          start_rotating_degree_pointer: 0, //指针初始旋转角度
          rotate_angle_pointer: 0, //指针将要旋转的度数
          rotate_transition: "transform 3s ease-in-out", //初始化选中的过度属性控制
          rotate_transition_pointer: "transform 6s ease-in-out", //初始化指针过度属性控制
        },
        canvasWidth: 0,
        jdt: {
          bfb:0,
          nowWidth: 0,
          count: 0,//一共几个刻度
          nextPoint: 0,//下次奖励在第几个刻度
          tipsLeft: 0,//下次奖励刻度提示位置
          nextGift: 0,//下次礼物名称
          nextStep: 0//下次礼物次数
        },
        val: 0,//获取到的中奖id
        valindex: 0,//转盘最终位置
        click_flag: true, //是否可以旋转抽奖
        roomid: 0,
        hammerId: 101,//同步消息时候需要告诉房间是什么类型转盘（暂定101、102但是102并未启用）
        msgShow: false,
        percentage: 0,
        userImg: 'https://i0.letvimg.com/lc04_lemf/201906/12/20/07/2x.png',
        giftItems: '', //抽奖dom结构
        arrNum: [0, 1, 2, 5, 8, 7, 6, 3], // 定义顺时针转动的顺序
        clickFlag: true, // 点击标识，防止重复点击
        prizeIndex: 0, //抽奖索引值
        play: false, // 九宫格是否轮询
        level: '', //复制中奖项
        position:null, //中奖奖品位置
      }
    },
    components: {
      [Popup.name]: Popup,
      [Progress.name]: Progress,
      'scroll-seamless': scroll
    },
    computed: {
      classOption () {
        return {
          direction: 2,
          step: 1,
          // singleWidth: this.canvasWidth,
          limitMoveNum: 10,
          // waitTime: 300,
          hoverStop: false,
          openTouch: false
        }
      }
    },
    watch: {
      pressMsgList: function (){
        this.$nextTick(function(){
          if (!this.canvasWidth){
            this.canvasWidth = this.$refs.listItem[0].offsetWidth;
          }
        })
      },
      "jdt.bfb": function (){
        this.$nextTick(function(){
          this.jdt.nowWidth = this.$refs.jdtbg.offsetWidth*(this.jdt.bfb >= 1? 0 : this.jdt.bfb);//当前进度条长度
          this.jdt.tipsLeft = this.$refs.kedu[this.jdt.nextPoint].offsetLeft;// 当前浮标位置
        })
      },
      pressTab: function (a,b){
        if (a !== b){
          this.getJDT();
        }
      }
    },
    async mounted (){
      await this.getDevice()//获取设备信息
      await this.getUser();// 获取用户信息
      this.bridgeRegister();//监听回调
    },
    methods: {
      /**
       * 渲染奖励列表数据
       */
      async getPrizeList (){
        let ret,
            url = `${this.API_DOMAIN}/sales/gift/list?pcode=${this.pcode}&version=${this.version}&all=1`;
        try {
          ret = await axios.get(url, { timeout: 3000 });
        } catch (error) {
          try {
            ret = await axios.get(url, { timeout: 3000 });
          } catch (error) {
            this.$notify(ret && ret.data && ret.data.message || '网络错误，请稍候再试')
            return
          }
        }
        let json = ret.data.data&&ret.data.data.list || {};
        if (!json){
          this.$notify('网络错误，请稍候再试')
          return
        }
        // 获取礼物数据
        var _this = this;
        json.filter(function(item) {
          for (let i = 0; i < _this.pressTabs.length; i++) {
            let giftId = _this.pressTabs[i];
            if (item.giftid == giftId){
              console.log(giftId);
              let giftIds = item.random_gift_list.replace(/\./g,'').replace(/:\w+/g,'').replace(/\|/g,',');
              _this.gifts.push({
                giftId: giftId,
                items: giftIds,
                list:[]
              });
            }
          }
        });

        for (let i = 0; i < _this.gifts.length; i++) {
          let giftList = _this.gifts[i].items.split(',');
          for (let k = 0; k < giftList.length; k++) {
            let oneGiftId = giftList[k];
            json.find((value) => {
              if (value.giftid == oneGiftId) {
                _this.gifts[i].list.push(value);
            console.log(value.giftid,k,value.name);
              }
            });
          }
          _this.gifts[i].list.splice(4,0,' '); //在数组中第五的位置新增一个空位置,添加抽奖按钮空白项
        }


        this.$nextTick(() => {
          this.giftItems = this.$refs.pice;
//          this.giftItems[4].classList.add("luck"); //中间抽奖按钮加类名
          this.prizeZhuan();
        });

      },
      /* 九宫格点击抽奖按钮逻辑 */
      prizeZhuan () {
        this.giftItems[4].onclick = () => {
          console.log('点击抽奖');
          //未登录调起登录
          if (!this.token || this.token === '') {
            dsBridge.call('openLoginWin')
            return
          }

          if (!this.click_flag) return
          this.click_flag = false;
          if (!this.clickFlag) return
          // 增加本地调试逻辑
          if (this.roomid !== 0 || window.location.host.match(/localhost/)) {
            this.getPrizeWeel();
          } else {
            dsBridge.call('getCurrentRoomAsync', async ret => {
              var id = JSON.parse(ret).id
              if(!id){
                id = JSON.parse(ret)['id:']
              }
              if(id){
                this.roomid = id
              }
              this.getPrizeWeel();
            })
          }
        }
      },
      /* 九宫格转动 */
      move () {
        if (this.prizeIndex === 0) {
          this.giftItems[this.arrNum[7]].classList.remove("active");
          this.giftItems[this.arrNum[this.prizeIndex]].classList.add("active");
          this.prizeIndex++
        } else if (this.prizeIndex === 8) {
          this.prizeIndex = 0
          this.giftItems[this.arrNum[7]].classList.remove("active");
          this.giftItems[this.arrNum[this.prizeIndex]].classList.add("active");
          this.prizeIndex++
        } else {
          this.giftItems[this.arrNum[this.prizeIndex - 1]].classList.remove("active");
          this.giftItems[this.arrNum[this.prizeIndex]].classList.add("active");
          this.prizeIndex++
        }
        //选中其中奖项停止
        if (this.level && this.giftItems[this.arrNum[this.prizeIndex-1]].type == this.level) {
          console.log('停止----','level:',this.level,'type:',this.giftItems[this.arrNum[this.prizeIndex-1]].type);
          clearInterval(this.timer1)
          clearInterval(this.timer2)
          this.stop()
        }
      },
      // 停止抽奖
      stop () {
        this.clickFlag = false// 不能点击
//        this.play = false; //九宫格暂停轮询
        this.prizeIndex = 0; //抽奖索引值为0
        // 旋转结束后，允许再次触发
        let during_time = 1; // 默认为1s
        setTimeout(()=> {
          this.click_flag = true;
          this.clickFlag = true// 不能点击
          this.msgShow = true;//获奖提示
          this.sendMsg();//获奖信息同步到房间
          // 更新抽奖按钮状态
          this.giftItems[4].classList.remove("announced");
          this.giftItems[4].classList.add("luck");
          // 将当前中奖状态清空,恢复默认抽奖状态
          this.giftItems.forEach((list) => {
            list.classList.remove("active");
          });
          this.level = '';
        }, during_time * 1000 + 500); // 延时，保证转盘转完
//        setTimeout(() => {this.popupShow = true},800)
      },
      // 转动降速
      lowSpeed () {
        clearInterval(this.timer1)
        this.clickFlag = false// 不能点击
        this.timer2 = setInterval(this.move, 300)
        setTimeout(() => { //抽中项延时赋值
          this.level = this.position;
        }, 1000)
      },


      // 获取全服中奖记录用于滚动播放
      async getPrizeMsg (){
        // 定时每10秒更新一次
        let ret,
            url = `${this.API_DOMAIN}/sales/game/winlist/${this.gameid}?pcode=${this.pcode}&version=${this.version}`;
        try {
          ret = await axios.get(url, { timeout: 3000 });
        } catch (error) {
          try {
            ret = await axios.get(url, { timeout: 3000 });
          } catch (error) {
            return
          }
        }
        let json = ret.data.data || '';
        if (!json){
          return
        } else {
          this.pressMsgList = [];
          this.pressMsgList = json.list;
        }
      },
      // 获取进度条奖品列表与进度条进度
      async getJDT (){
        // 定时每10秒更新一次
        let ret,
            url = `${this.API_DOMAIN}/sales/game/bar/${this.gameid}/${this.pressTab}?pcode=${this.pcode}&version=${this.version}`;
        try {
          ret = await axios.get(url, { timeout: 3000 });
        } catch (error) {
          try {
            ret = await axios.get(url, { timeout: 3000 });
          } catch (error) {
            this.$notify(ret && ret.data && ret.data.message || '进度条网络错误获取失败稍后会继续尝试')
            return
          }
        }
        let json = ret.data.data || '';
        this.jdt.count = json.points+1;//一共有多少个刻度
        this.jdt.nextPoint = json.next_reward_point; //下次奖励在第几个刻度
        this.jdt.nextStep = json.next_reward_step;//下次奖励在第几个次
        this.jdt.nextGift = json.next_reward_gift.name;//下次礼物名称
        this.jdt.bfb = parseInt(json.current_step-json.start_step)/parseInt(json.end_step-json.start_step);
        // this.jdt.nextGift = json.next_reward_gift.nums;//下次礼物个数
      },
      // 转盘点击抽奖按钮逻辑
      async clickZPBtn () {
        if (!this.token || this.token === '') {
          dsBridge.call('openLoginWin')
          return
        }
        if (!this.click_flag) return
        this.click_flag = false;
        if (this.roomid !== 0) {
          await this.getPrize();
        } else {
          dsBridge.call('getCurrentRoomAsync', async ret => {
            var id = JSON.parse(ret).id
            if(!id){
              id = JSON.parse(ret)['id:']
            }
            if(id){
              this.roomid = id
            }
            await this.getPrize();
          })
        }
      },


      async getDevice(){
//        navigator.userAgent.toLowerCase().match(/isapp/i) == "isapp"
        // 增加本地调试
        if(window.location.host.match(/localhost/)) {
          await this.getPrizeList();// 获取奖品列表
          await this.timeDown();// 获取全服中奖信息
        }else {
          dsBridge.call('getAppInfoAsync', async ret => {
            const appInfo = JSON.parse(ret);
            this.pcode = appInfo.pcode;
            this.version = appInfo.version;
            await this.getPrizeList();// 获取奖品列表
            await this.timeDown();// 获取全服中奖信息
          });
        }
      },
      async getUser (){
        // 增加本地调试
        if(window.location.host.match(/localhost/)) {
          await this.getUserInfo();
          await this.getMoney();
        }else{
          dsBridge.call('getTokenAsync',async ret => {
            try {
              const userInfo = JSON.parse(ret)
              this.token = userInfo.token
              if (!this.token || this.token === '') {
                this.user.name = '请登录'
                this.user.money = '0'
                return
              }
              await this.getUserInfo();
              await this.getMoney();
            } catch (e) {
              this.$notify('未知错误！，请刷新页面')
            }
          });
        }
        dsBridge.call('getCurrentRoomAsync', ret => {
          var id = JSON.parse(ret).id;
          if(!id){
            id = JSON.parse(ret)['id:'];
          }
          if(id){
            this.roomid = id
          }
        });
      },
      // 获取用户信息
      async getUserInfo (){
        let userRet,
            userUrl = `${this.API_DOMAIN}/ucenter/userinfo?accesstoken=${this.token}&pcode=${this.pcode}&version=${this.version}`;
        try {
          userRet = await axios.get(userUrl, { timeout: 3000 });
        } catch (error) {
          try {
            userRet = await axios.get(userUrl, { timeout: 3000 });
          } catch (error) {
            this.$notify('获取用户信息失败！，请刷新页面')
            return
          }
        }
        let userData = userRet.data.data || '';
        if (!userData){
          this.$notify('获取用户信息失败！，请刷新页面')
          return
        }
        this.user.headImg = userData.avatar_imgurl || this.userImg;
        this.user.name = userData.username || '';
      },
      // 获得钱包信息
      async getMoney (){
        let walletRet,
            walletUrl = `${this.API_DOMAIN}/sales/wallet?accesstoken=${this.token}&pcode=${this.pcode}&version=${this.version}`;
        try {
          walletRet = await axios.get(walletUrl, { timeout: 3000 });
        } catch (error) {
          try {
            walletRet = await axios.get(walletUrl, { timeout: 3000 });
          } catch (error) {
            this.$notify('获取钱包信息失败！，请刷新页面')
            return
          }
        }
        let walletData = walletRet.data.data || '';
        if (!walletData){
          this.$notify('获取用户信息失败！，请刷新页面')
          return
        }
        this.user.money = walletData.coin_amount || 0;
      },
      /**
       * 游戏-大转盘接口
       * http://wiki.letv.cn/pages/viewpage.action?pageId=81901603
       */
      async getPrizeWeel(){
        this.clickFlag = false; // 按钮不可点击
        let prizeRet, prizeUrl = `${this.API_DOMAIN}/sales/game/draw/${this.num}?playid=${this.pressTab}&accesstoken=${this.token}&roomid=${this.roomid || 1001}&pcode=${this.pcode}&version=${this.version}`;
        try {
          prizeRet = await axios.get(prizeUrl, { timeout: 3000 });
        } catch (error) {
          try {
            prizeRet = await axios.get(prizeUrl, { timeout: 3000 });
          } catch (error) {
            this.click_flag = true;
            this.$notify('网络错误，获取中奖信息失败！')
            return
          }
        }

        let prizeData = prizeRet.data || '';
        if (!prizeData || prizeData.code !== 0){
          this.$notify('网络错误，获取中奖信息失败！')
          if (!prizeData.message){
            this.$toast.fail('网络错误，获取中奖信息失败！')
          } else {
            this.$toast.fail(prizeData.message)
          }
          this.click_flag = true;
          return
        }
        console.log(prizeData.data.list[0].giftid,prizeData.data.list[0].name);
        // 阶段奖励
        this.rewardPrize = prizeData.data.reward || [];
        // 由大到小排序
        this.prize = prizeData.data.list.sort(this.up) || '';
        this.allSum = this.sum(this.prize);
        console.log(this.gifts[this.pressTabClass].items);
        this.gifts[this.pressTabClass].items.split(',').find((value, index) => {
          console.log(value,index);
          if (value == this.prize[0].giftid) {
            this.val = index;
            this.position = index+1;
          }
        });
        // 抽奖按钮图片状态更换
        this.giftItems[4].classList.contains('luck')? this.giftItems[4].classList.remove("luck"):'';
        this.giftItems[4].classList.add("announced");
        // 九宫格动效
        this.timer1 = setInterval(this.move, 100);
        setTimeout(() => {
          clearInterval(this.timer1)
          this.lowSpeed()
        }, 2000)

        console.log('默认当前level:',this.level);
        await this.getMoney();//更新钱包
        await this.getJDT();// 更新进度条
      },
      async getPrize (){
        let prizeRet,
            prizeUrl = `${this.API_DOMAIN}/sales/game/draw/${this.num}?playid=${this.pressTab}&accesstoken=${this.token}&roomid=${this.roomid || 1001}&pcode=${this.pcode}&version=${this.version}`;
        try {
          prizeRet = await axios.get(prizeUrl, { timeout: 3000 });
        } catch (error) {
          try {
            prizeRet = await axios.get(prizeUrl, { timeout: 3000 });
          } catch (error) {
            this.click_flag = true;
            this.$notify('网络错误，获取中奖信息失败！')
            return
          }
        }
        let prizeData = prizeRet.data || '';
        if (!prizeData || prizeData.code !== 0){
          this.$notify('网络错误，获取中奖信息失败！')
          if (!prizeData.message){
            this.$toast.fail('网络错误，获取中奖信息失败！')
          } else {
            this.$toast.fail(prizeData.message)
          }
          this.click_flag = true;
          return
        }
        // 阶段奖励
        this.rewardPrize = prizeData.data.reward || [];
        // 由大到小排序
        this.prize = prizeData.data.list.sort(this.up) || '';
        this.allSum = this.sum(this.prize);
        this.gifts[this.pressTabClass].items.split(',').find((value, index) => {
          if (value == this.prize[0].giftid) {
            this.val = index;
          }
        });
        await this.getMoney();//更新钱包
        await this.getJDT();// 更新进度条
        this.rotating();//启动转盘
      },
      async timeDown(){
        var i = 10;
        const updateTime = async () => {
          if(i == 0){
            // console.log('10秒时间到了，获取全服中奖信息')
            i = 10;
          }
          if (i == 10){
            await this.getPrizeMsg();//中奖跑马灯
            await this.getJDT();// 获取进度条信息
          }
          i--;
        };
        setInterval(updateTime,1000);
      },
      async goOn (){
        this.msgShow = false
        await this.clickZPBtn()
      },
      sendMsg (){
        if (this.allSum <= this.pressPrizes[this.pressTabClass][this.num]) return
        dsBridge.call(
          'sendMsgAsync',
          {
            type: 'playGameMsg',
            gameId: 1,//1代表大转盘
            msg: {
              giftId: this.prize[0].giftid,
              giftName: this.prize[0].name,
              price: this.prize[0].price,
              count: 1,
              icon: this.prize[0].icon,
              gameName: '幸运大转盘',
              hammerId: this.hammerId,
              hammerName: '幸运大转盘',
              hammerCount: 1
            }
          },
          function (ret) {
          }
        )
      },
      recharge: function () {
        if (!this.token || this.token === '') {
          dsBridge.call('openLoginWin')
          return
        }
        dsBridge.call('openRechargeWin');
      },
      bridgeRegister (){
        // 登录回调
        dsBridge.register('loginCallback', function (ret) {
          ret = JSON.parse(ret)
          if (ret.err === 0) {
            setTimeout(function () {
              window.location.reload();
            }, 30)
          }
        });
        // 充值完回调
        dsBridge.register('rechargeCallback', () => {
          this.getMoney();
        });
      },
      changeNum (num){
        this.num = num;
      },
      tabChange(index){
        if (!this.click_flag) {
          this.$toast.fail("转盘已开始");
          return
        }
        this.pressTabClass = index;
        this.pressTab = this.pressTabs[index];
        this.num = 1;
      },
      rotating() {
        let type = 0; // 默认为 0  转盘转动 1 箭头和转盘都转动(暂且遗留)
        let during_time = 3; // 默认为1s
        let rand_circle = 6; // 附加多转几圈，2-3
        let result_angle = [1, 315, 270, 225, 180, 134, 90, 45]; //最终会旋转到下标的位置所需要的度数，从指针初始位置开始算度数，顺时针或逆时针
        // 奖励换算,最终要旋转到哪一块(8个位置从0开始)
        if (this.val <=7){
          this.valindex = this.val;
        }else {
          return
        }
        if (type == 0) {
          // 转动盘子
          var rotate_angle =this.turntable.start_rotating_degree + rand_circle * 360 +result_angle[this.valindex] - this.turntable.start_rotating_degree % 360;
          this.turntable.start_rotating_degree = rotate_angle;
          this.turntable.rotate_angle = "rotate(" + rotate_angle + "deg)";
          var that = this;
          // 旋转结束后，允许再次触发
          setTimeout(function() {
              that.click_flag = true;
              that.msgShow = true;//获奖提示
              that.sendMsg();//获奖信息同步到房间
          }, during_time * 1000 + 500); // 延时，保证转盘转完
        } else {
          // 转动盘子和指针
        }
      },
      openShop () {
        dsBridge.call('openExchangeStore');
      },
      openPrize () {
        window.location.href = window.location.href.replace('/sy/dzp', '/sy/dzp/prize')
      },
      openInfo (){
        // 获取需要滚动的距离
        document.getElementById("hdgz").scrollIntoView();
        // window.location.href = window.location.href.replace('/sy/dzp', '/sy/game/info')
      },
      up(x,y){
        return y.price-x.price
      },
      sum(data){
        let s = 0;
        for (let i = 0; i < data.length; i++) {
          s += parseInt(data[i].price) * parseInt(data[i].nums);
        }
        return s;
      }
    }
  }

</script>

<style>
  body,
  html {
    user-select:none;
    height: 100%;
  }

  #app {
    height: 100%;
  }
  .wrapper {
    min-height: 100%;
    font-size: 12px;
    position: relative;
    overflow:hidden;
  }
  .overlayClass {
    background: rgba(0,0,0,0);
  }
  .wheel-main {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 167px;
    left: 50%;
    margin-left: -135px;
    overflow:hidden;
  }
  .wheel-bg {
    width: 270px;
	  height: 270px;
    background: url("../../assets/img/sy/dzp/zp.png") no-repeat center top;
    background-size: 100%;
    color: #fff;
    font-weight: 500;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    transition: transform 3s ease;
  }
  .tabBtn {
    display: flex;
    justify-content: center;
    align-items : center;
    height: 29px;
    margin-left: 18px;
  }
  .tabBtn img {
    margin-top: 3px;
    width: 75px;
	  height: 29px;
  }
  .wheel-pointer-box {
    position: absolute;
    top:  50%;
    left: 50%;
    z-index: 100;
    -webkit-transform: translate(-50%,-60%);
    transform: translate(-50%, -60%)
  }
  .wheel-pointer {
    width: 80px;
    height: 88px;
    background: url("../../assets/img/sy/dzp/btn.png") no-repeat ;
    background-size: 100%;
    transform-origin: center 60%;
  }
  .wheel-bg div {
    text-align: center;
  }
  .prize-list {
    width: 100%;
    height: 100%;
    position: relative;
  }
  .prize-list .prize-item {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction:column;
    position: absolute;
    width: 2rem;
    top: 0;
    left: 0;
    z-index: 2;
    color: #ffebaf;
  }
  .prize-list .prize-item:first-child {
    top: 0.9rem;
    left: 2.6rem;
    transform: rotate(0deg);
  }
  .prize-list .prize-item:nth-child(2) {
    top: 1.5rem;
    left: 4.1rem;
    transform: rotate(45deg);
    color: #e67200;
  }
  .prize-list .prize-item:nth-child(3) {
    top: 3rem;
    left: 4.6rem;
    transform: rotate(-270deg);
  }
  .prize-list .prize-item:nth-child(4) {
    top: 4.4rem;
    left: 4rem;
    transform: rotate(-225deg);
    color: #e67200;
  }
  .prize-list .prize-item:nth-child(5) {
    top: 5rem;
    left: 2.6rem;
    transform: rotate(-180deg);
  }
  .prize-list .prize-item:nth-child(6) {
    top: 4.4rem;
    left: 1.1rem;
    transform: rotate(-135deg);
    color: #e67200;
  }
  .prize-list .prize-item:nth-child(7) {
    top: 3rem;
    left: 0.6rem;
    transform: rotate(-90deg);
  }
  .prize-list .prize-item:nth-child(8) {
    top: 1.6rem;
    left: 1.2rem;
    transform: rotate(-45deg);
    color: #e67200;
  }
  .prize-pic {
    width: 42px;
    height: 30px;
  }
  .prize-pic img {
    width: 42px;
    height: 30px;
  }
  .prize-count {
    font-size: .4rem;
  }
  .prize-type {
    font-size: 12px;
    transform:scale(.75);
  }
  .header {
    display: flex;
    align-items: center;
    justify-content : space-between;
    position: absolute;
    top: 14px;
    left: 0px;
    width:100%;
    height: 29px;
  }
  .login {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 60px;
    height: 21px;
    /* background-color: #de0b3b; */
    border-radius: 0px 11px 11px 0px;
    color: #fff;
    line-height: 21px;
    margin-left: 23px;
  }
  .login span{
    max-width: 100px;
    min-width: 60px;
    font-family: PingFangSC-Regular;
    font-weight: normal;
    font-stretch: normal;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    letter-spacing: 0px;
    margin-left: 4px;
    padding-right: 4px;
  }
  .login img{
    width: 21px;
    height:21px;
    border-radius: 12px 12px;
    margin-left: -10px;
  }
  .goPay {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 18px;
    color: #fff;
    height:29px;
    background-color: rgb(241,95,166);
    border-radius: 15px;
    height: 29px;
    padding:0 3px;
  }
  .goPay span{
    font-family: PingFangSC-Medium;
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    margin-right: 10px;
    margin-left:10px;
  }
  .goPay img {
    margin-left:7px;
    width: 19px;
    height: 19px;
  }
  .msgBox {
    width: 230px;
    height: 28px;
    position: absolute;
    top: 57px;
    left: 50%;
    margin-left:-115px;
    line-height: 28px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    overflow:hidden;
  }
  .msgBox .msgListBox {
    display:flex;
    justify-content: flex-start;
    height: 28px;
  }
  .msgBox .list-item {
    display: flex;
    justify-content: flex-start;
    /* width: 232px; */
    margin-right: 28px;
    max-height: 28px;
  }
  .msgBox .list-item .name {
    max-width: 125px;
    overflow:hidden;
    text-overflow:ellipsis;/* 超出部分显示省略号 */
    white-space: nowrap;
    margin-left: 4px;
    color: #ffffff;
  }
  .msgBox .list-item .chouzhong {
    margin-left: 6px;
    color: #ffffff;
  }
  .msgBox .list-item .give {
    margin-left: 6px;
    color: #ffe958;
  }
  .twoBtn {
    width: 21px;
    height: 200px;
    display: flex;
    flex-direction:column;
    align-content: space-between;
    justify-content : space-between;
    position:absolute;
    top: 69px;
    right: 0px;
  }
  .twoBtn img {
    width: 21px;
	  height: 59px;
  }
  .press {
    width: 284px;
    height: 47px;
    display: flex;
    align-items: center;
    justify-content : space-between;
    position:absolute;
    top: 112px;
    left: 50%;
    margin-left: -142px;
  }
  .press .pressBtn {
    position: relative;
  }
  .press .pressBtn img{
    width: 80px;
    height: 47px;
  }
  .press .pressBtn i {
    display:block;
    width: 15px;
    height: 19px;
    position:absolute;
    bottom: 0px;
    left: 50%;
    margin-left: -6px;
    margin-bottom: -2px;
  }
  .press .pressBtn i {
    background: url('../../assets/img/sy/dzp/wxz.png') no-repeat 0 0;
    background-size: 100%;

  }
  .press .pressBtn.yes i {
    background: url('../../assets/img/sy/dzp/xz.png') no-repeat 0 0;
    background-size: 100%;
  }

  .van-popup {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction:column;
    background: #ffffff;
    width: 100%;
  }
  .luckBox {
    display: flex;
    align-items: center;
    width: 335px;
    overflow:hidden;
    overflow-x: scroll;
    overflow-y: hidden;
    margin-top: 15px;
    padding-bottom: 39px;
  }
  .lwTitle{
    width: 100%;
    height: 44px;
  }
  .lwTitle img{
    width: 100%;
    height: 44px;
  }
  .luckBox::-webkit-scrollbar {
    display: none;
  }
  .bigLucks{
    display: flex;
    align-items: center;
    width: 335px;
    overflow:hidden;
    overflow-x: scroll;
    overflow-y: hidden;
    margin-top:9px;
  }
  .bigLucks .luckImgBg{
    display: flex;
    align-items: center;
    flex-direction:column;
    padding-left: 17px;
    padding-right: 17px;
    width: 75px;
    height: 75px;
    background: url('../../assets/img/sy/dzp/tslwbg.png') no-repeat center center;
    background-size: 75px 75px;
  }
  .bigLucks .luckImgBg .bigLkT {
    text-align: center;
    color: #ffffff;
    height: 20px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 20px;
    letter-spacing: 0px;
    color: #ffffff;
  }
  .bigLucks .luckImg {
    width: 70px;
  }
  .luckBox .lucksBox .luckText{
    position: absolute;
    bottom: -23px;
    right: 5px;
    width: 24px;
    height: 24px;
    background-color: #ff819c;
    border: solid 1px #ffffff;
    border-radius: 24px;
    text-align:center;
    font-family: PingFangSC-Medium;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 24px;
    letter-spacing: 0px;
    color: #ffffff;
  }
  .luckBox .lucksBox .luckImgBg{
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 75px;
    height: 75px;
    padding-left: 17px;
    padding-right: 17px;
    background: url('../../assets/img/sy/dzp/lwbg.png') no-repeat center center;
    background-size: 75px 75px;
  }
  .luckBox .lucksBox .luckImg{
    width: 70px;
  }
  .wrapper #jdt {
    width: 275px;
    height: 24px;
    border-radius: 12px;
    position:absolute;
    top: 522px;
    left: 50%;
    margin-left: -137.5px;
  }
  .wrapper #jdt .jdtbg{
    position:relative;
    width: 275px;
    height: 24px;
    background:rgb(243,61,237);
    border-radius: 12px;
    overflow: hidden;
  }
  .wrapper #jdt .jdtbg .keduBox{
    width: 275px;
    height: 24px;
    display:flex;
    justify-content : space-between;
    align-items : center;
  }
  .wrapper .jdtc{
    position: absolute;
    top:2px;
    left: 2px;
    height: 20px;
    background: linear-gradient(0deg, rgb(255,199,78) 0%, rgb(255,240,114) 100%);
    border-radius: 18px;
    transition: width 2s;
  }
  .wrapper #jdt .tipBox{
    position:absolute;
    top: -34px;
    background: rgba(255,255,255,.75);
    border-radius: 3px;
  }
  .wrapper #jdt .sanjiao{
    position:absolute;
    top: -6px;
    content:"";
    width: 0;
    height: 0;
    border-width: 5px;
    border-style: solid;
    border-color:rgba(255,255,255,.75) transparent transparent transparent;
  }
  .wrapper #jdt .tipBox .h4{
    width: 125px;
    display:flex;
    flex-direction:column;
    align-items : center;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 15px;
    letter-spacing: 0px;
    color: #fb1949;
    transform:scale(0.75);
  }
  .wrapper #jdt .kedu {
    width: 2px;
    height: 12px;
    background: rgb(216,162,255);
    border-radius: 1px;
  }
  .wrapper #jdt .kedu.active{
    height: 18px;
  }
  .wrapper #hdgz {
    width: 100%;
    height: 1px;
    position:absolute;
    top: 700px;
  }
  
  /*九宫格*/
  .luckBg{
    padding:2%;
  }
  .luckList{
    margin:-2.5% 0 0 -2.5%
  }
  .weel-pointer-box {
    width: 300px;
    height: 314px;
    position: absolute;
    top:  43.1%;
    left: 50%;
    z-index: 100;
    transform: translate(-50%, -60%);
    border-radius: 5px;
    background: rgb(251,137,255);
  }
  .luckList .item{
    position: relative;
    float: left;
    width: 30.6%;
    padding-bottom: 32.6%;
    margin: 2.5% 0 0 2.5%;
    text-align: center;
    background: url('../../assets/img/sy/dzp/prizeBg.png') no-repeat center center;
    background-size: cover;
    height: 0;
    overflow: hidden;
  }
  .luckList .item.luck{
    background-image:url(../../assets/img/sy/dzp/clickDraw.png);
  }
  .luckList .item.winPrize{
    background-image:url(../../assets/img/sy/dzp/winPrizeBg.png);
  }
  .luckList .item.winPrize .name{
    color: #fff
  }
  .luckList .item.announced{
    background-image: url('../../assets/img/sy/dzp/announced.png');
    color: #fff
  }
  .luckList .item .border{
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  }
  .luckList .item.active .border{
    background-image: url(../../assets/img/sy/dzp/focus.png);
    background-repeat:no-repeat;
    background-size: 100%;
  }
  .luckList .item>div{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .luckList .item img{
    width: 90%;
    height: 62%;
  }
  .luckList .item .name{
    display: block;
    width: 90%;
    margin: 0 auto;
    font-size: 12px;
    color: rgb(148,39,255);
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
